<template>
    <rkm-table
        :fields="fields"
        :filter="model.filter"
        :items="salas"
        ref="Table"
    >
        <template v-slot:filters>
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Unidade"
                        :value="lotacao.infraestrutura.unidade.nomeFantasia"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        disabled
                        label="Local de atendimento"
                        :value="lotacao.infraestrutura.nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        label="Buscar"
                        placeholder="Digite para buscar"
                        v-model="model.filter"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <template v-slot:cell(actions)="{ index, item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-sala-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-sala"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(index, item.id)"
                color="danger"
                authorize="destroy-cadastro-sala"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
    },
    created() {

        this.repositories = {
            sala: this.getConectaSusRepository('cadastro.estabelecimento.sala')
        }

        this.load()
    },
    data: () => ({
        fields: [
            {
                name: 'setor',
                key: 'setorNome',
                label: 'Setor',
                searchable: true,
                sortable: true
            },
            {
                name: 'nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        model: {
            filter: ''
        },
        salas: []
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.sala.datatable()
                .then(({ data }) => this.salas = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(index, id) {

            const destroy = () => this.repositories.sala.destroy(id)
                .then(() => this.salas.splice(index, 1))

            this.showDeleteConfirmation('Deseja realmente excluir a sala?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
}
</script>